module.exports = __webpack_public_path__ + "static/media/ic_menu_sp.e6724ecb.svg";